var topsort = require('./topsort')

module.exports = isAcyclic

function isAcyclic (g) {
  try {
    topsort(g)
  } catch (e) {
    if (e instanceof topsort.CycleException) {
      return false
    }
    throw e
  }
  return true
}



//////////////////
// WEBPACK FOOTER
// ./~/graphlibrary/lib/alg/is-acyclic.js
// module id = 1621
// module chunks = 0